import styled from 'styled-components';

import { ImageWrapper } from '@mlb/react-patterns/components/Image/image.style';
import {
    DataWrapper,
    NameWrapper,
    DesktopRecordWrapper,
    DesktopStandingsWrapper
} from '@mlb/react-patterns/components/Team/team.style';

import GDBREAKPOINTS from '../themes/breakpoints';

const { SM_MIN, MD } = GDBREAKPOINTS;

export const PreviewInfoMain = styled.div`
    font-size: 12px;
    line-height: 12px;
    font-weight: 700;
    display: flex;
    justify-content: center;
`;

export const PreviewInfoSubWrapper = styled.div`
    font-size: 12px;
    line-height: 12px;
    color: var(--gameday-secondary-font-color);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    margin-top: var(--gameday-section-padding-sm);
    padding-top: 8px;
    border-top: 1px solid var(--gameday-wrap-section-divider);
`;

export const PreviewInfoSub = styled.span`
    display: block;
    @media (min-width: ${SM_MIN}) {
        display: inline-block;
    }
`;

export const PreviewInfoSubDivider = styled.span`
    display: inline-block;
    color: var(--gameday-secondary-font-color);
`;

export const PreviewDetailsWrapper = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
`;

export const DetailsTeamWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const TeamWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: ${({ alignRight }) => alignRight ? 'flex-end' : 'flex-start'};
    ${DataWrapper} {
        --wrapper-margin: calc(var(--gameday-section-padding-sm) / 2);
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 4px;
        ${({ alignRight }) => alignRight ? 'margin-left: var(--wrapper-margin);' : 'margin-right: var(--wrapper-margin);'}
    }
    ${NameWrapper} {
        color: var(--gameday-primary-font-color);
        display: block;
        font-size: 12px;
        line-height: 12px;
        font-weight: 700;
        margin: 0;
        border-bottom: none;
    }
    ${DesktopRecordWrapper} {
        color: var(--gameday-secondary-font-color);
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        margin: 0;
    }
    ${DesktopStandingsWrapper} {
        color: var(--gameday-primary-font-color);
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        margin: 0;
    }
    @media (min-width: ${MD}) {
        ${DataWrapper} {
            ${({ alignRight }) => alignRight ? 'margin-left: var(--gameday-section-padding-sm);' : 'margin-right: var(--gameday-section-padding-sm);'}
        }
    }
    ${ImageWrapper} {
        /*
        TODO: There's a bug in patters where logoSize is added to the css,
        but Team only allows a number as that prop. Might be a breaking change
        in patterns to fix.
        */
        width: ${({ logoSize }) => `${logoSize}px`};
        height: ${({ logoSize }) => `${logoSize}px`};

        img {
            margin-top: 0;
        }
    }
`;

export const PreviewInfoWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    background-color: var(--gameday-background-color);
    padding: 0px var(--gameday-section-padding-sm);
`;
